import { render, staticRenderFns } from "./TasksDay.vue?vue&type=template&id=5aa7bf9e"
import script from "./TasksDay.vue?vue&type=script&lang=js"
export * from "./TasksDay.vue?vue&type=script&lang=js"
import style0 from "./TasksDay.vue?vue&type=style&index=0&id=5aa7bf9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports